import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Logowanie from './Log';


ReactDOM.render(<Logowanie />, document.getElementById('root'));